import { render } from '@testing-library/react';
import { BrowserRouter } from 'react-router-dom';
import { ROUTE_INFO } from './Route.constants';
import { RouteType } from './Route.types';
import React from 'react';

const AdminDashboard = React.lazy(
  () => import('../adminDashboard/AdminDashboard')
);
const AdminCreateReport = React.lazy(
  () => import('../adminReportForm/AdminCreateReport')
);

const AdminEditReport = React.lazy(
  () => import('../adminReportForm/AdminEditReport')
);

const UserDashboard = React.lazy(
  () => import('../userDashboard/UserDashboard')
);
const UserEditReport = React.lazy(
  () => import('../userEditReport/UserEditReport')
);
const ReportViewer = React.lazy(() => import('../reportViewer/ReportViewer'));

const HomePage = React.lazy(() => import('../common/HomePage'));

const UserConfigureReport = React.lazy(
  () => import('../userConfigureReport/UserConfigureReport')
);
const RunSavedReport = React.lazy(
  () => import('../runSavedReport/RunSavedReport')
);
const ReportSnapshot = React.lazy(
  () => import('../reportSnapshot/ReportSnapshot')
);

export const renderWithRouter = (ui: JSX.Element, { route = '/' } = {}) => {
  window.history.pushState({}, 'Test Page', route);

  return render(ui, { wrapper: BrowserRouter });
};

export const getRoutes = (adminRoles: string[]): RouteType[] => {
  return [
    {
      path: ROUTE_INFO.adminDashboard.path,
      component: AdminDashboard,
      label: ROUTE_INFO.adminDashboard.label,
      exact: true,
      roles: [...adminRoles],
    },
    {
      path: ROUTE_INFO.adminCreateReport.path,
      component: AdminCreateReport,
      label: ROUTE_INFO.adminCreateReport.label,
      roles: [...adminRoles],
    },
    {
      path: ROUTE_INFO.adminEditReport.path,
      component: AdminEditReport,
      label: ROUTE_INFO.adminEditReport.label,
      roles: [...adminRoles],
    },
    {
      path: ROUTE_INFO.userEditReport.path,
      component: UserEditReport,
      label: ROUTE_INFO.userEditReport.label,
    },
    {
      path: ROUTE_INFO.runReport.path,
      component: ReportViewer,
      label: ROUTE_INFO.runReport.label,
    },
    {
      path: ROUTE_INFO.userDashboard.path,
      component: UserDashboard,
      label: ROUTE_INFO.userDashboard.label,
    },
    {
      path: ROUTE_INFO.homePage.path,
      component: HomePage,
      label: ROUTE_INFO.homePage.label,
      exact: true,
    },
    {
      path: ROUTE_INFO.userConfigureReport.path,
      component: UserConfigureReport,
      label: ROUTE_INFO.userConfigureReport.label,
    },
    {
      path: ROUTE_INFO.runSavedReport.path,
      component: RunSavedReport,
      label: ROUTE_INFO.runSavedReport.label,
    },
    {
      path: ROUTE_INFO.viewReportSnapshot.path,
      component: ReportSnapshot,
      label: ROUTE_INFO.viewReportSnapshot.label,
    },
  ];
};
